<template>
  <div class="equity-wrap">
    <!-- <div class="title">专业版权益</div> -->
    <div class="my-font-xs">
      <!-- 分组 -->
      <div class="my-p-t-10 my-p-b-10" v-for="(group,index) in dataList" :key="index">
        <div class="my-p-10" style="background: linear-gradient(to right, #FDF6EC 20%, #fff 80%);">
          <!-- 标题 -->
          <div class="u-font-lg" style="color:#E6A23C">{{group.title}}</div>
          <!-- 副标题 -->
          <div class="color-info my-p-t-2">{{group.desc}}</div>
        </div>
        <div class="my-flex" style="flex-wrap: wrap;">
          <!-- 子项 -->
          <div
            class="my-flex item my-row-center my-m-t-10 my-p-10"
            style="flex-direction: column; text-align: center;border-radius: 10px;"
            :style="{
              width:utils.getDialogWidth() > 320 ? '20%' :'25%'
            }"
            v-for="(item,index2) in group.items"
            :key="index2"
          >
            <!-- 图标 -->
            <div class="itemIcon my-flex my-row-center" style="background-color: #FFF5E0; border-radius: 100%; width: 40px;height:40px;">
              <i :class="item.icon_Web" style="font-size: 20px; color: #EF9048;"></i>
            </div>

            <!-- 名称 -->
            <div class="itemTitle my-p-t-10 color-info">{{item.name}}</div>
            <!-- 描述 -->
            <div class="itemDesc my-p-t-5 color-info">{{item.desc}}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {}
  },
  props: {
    dataList: {
      type: Array,
      default: () => []
    }
  },
  watch: {},
  computed: {},
  created() {},
  methods: {}
}
</script>

<style lang="scss" scoped>
.equity-wrap {
  .item {
    cursor: pointer;
    &:hover {
      background: linear-gradient(306deg, #fff5e0, #fff5e0);
      .itemIcon {
        background: #ef9048 !important;
      }
      i {
        color: #fff !important;
      }
      .itemTitle {
        color: #ef9048 !important;
      }
      .itemDesc {
        color: #ef9048 !important;
      }
    }
  }
}
</style>